import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportRfidSingleVoyageLazy
} from "@containers/singleVoyage/reports/reportRfid/ReportRfidSingleVoyage.lazy";


const ReportRfidSingleVoyagePage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportRfidSingleVoyageLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportRfidSingleVoyagePage;
